import { FC } from 'react';
import { Link } from '@mui/material';
import DspUtils from '../../../../../utils/DspUtils';
import { Platform } from '../../../../../types/Campaign';

interface Props {
    dspEntityId: string;
    dspCampaignId: string;
    platform: Platform;
    dv360AdvertiserId?: string;
}

const DspCampaignLink: FC<Props> = ({ dspEntityId, dspCampaignId, platform, dv360AdvertiserId }) => {
    return (
        <Link
            href={DspUtils.getOrderUrl(dspEntityId, dspCampaignId, platform, dv360AdvertiserId)}
            target="_blank"
            fontWeight={500}
            fontSize={(theme) => theme.typography.body2.fontSize}
        >
            {platform === Platform.AMAZON ? 'Go to Amazon DSP' : 'Go to DV360'}
        </Link>
    );
};

export type { Props as DpsCampaignLinkProps };
export default DspCampaignLink;
